import * as React$1 from "react";

//#region src/components/icon/static/deliver-box.svg
var _path;
function _extends() {
	return _extends = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends.apply(null, arguments);
}
var SvgDeliverBox = function SvgDeliverBox$1(props) {
	return /* @__PURE__ */ React$1.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24
	}, props), _path || (_path = /* @__PURE__ */ React$1.createElement("path", { d: "M1.934 20.382a1.1 1.1 0 0 1-.808-.329q-.33-.33-.33-.808 0-.48.33-.808.33-.33.808-.33h3.863v-1.784H2.934a1.1 1.1 0 0 1-.808-.33q-.33-.33-.33-.808t.33-.808q.33-.33.808-.33h2.863v-1.79H3.984a1.1 1.1 0 0 1-.808-.33 1.1 1.1 0 0 1-.33-.808q0-.478.33-.808t.808-.33h1.813V7.02L4.266 3.702a1.08 1.08 0 0 1-.038-.864q.162-.441.59-.64.424-.199.862-.038.438.162.637.584l1.985 4.238h11.396l-1.53-3.274a1.1 1.1 0 0 1-.038-.87q.161-.441.59-.64.424-.199.861-.038a1.1 1.1 0 0 1 .638.584l1.76 3.784q.112.23.168.47t.056.494v10.615q0 .945-.665 1.61t-1.61.665zM12 13.257h4q.444 0 .746-.303.302-.302.302-.745t-.302-.742-.746-.3h-4q-.443 0-.745.3-.303.3-.303.742 0 .444.303.745.302.303.745.303m-3.928 4.85h11.856v-8.85H8.072z" })));
};
var deliver_box_default = SvgDeliverBox;

//#endregion
export { deliver_box_default as default };